var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 26 26",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.389,10.894c-0,1.04 -0.3,1.833 -0.9,2.38c-0.587,0.533 -1.427,0.813 -2.52,0.84l-0.58,2.98l-0.92,-4.8c1.626,-0 2.7,-0.12 3.22,-0.36c0.52,-0.267 0.78,-0.707 0.78,-1.32c-0,-0.747 -0.274,-1.354 -0.82,-1.82c-0.547,-0.467 -1.167,-0.7 -1.86,-0.7c-0.68,-0 -1.32,0.113 -1.92,0.34l-0,-2.26c0.4,-0.134 0.813,-0.2 1.24,-0.2c1.146,-0 2.146,0.486 3,1.46c0.853,0.973 1.28,2.126 1.28,3.46Zm-4.02,9.74l-1.72,-1.72l1.72,-1.7l1.68,1.7l-1.68,1.72Z",
    style: {
      fill: "#fff",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 10.595,
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: "0.85px"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.6bbfd7033c26eea2296a104ff83716a2.svg";
export { ForwardRef as ReactComponent };